import { createFileRoute } from '@tanstack/react-router'
import { CustomToolsManager } from '../../../../components/CustomToolsManager'

export const Route = createFileRoute('/desa/$slug/dashboard/custom-tools')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <CustomToolsManager desaId={desaId} />
  },
})
